import type {
  Theme,
  ThemeOptions,
  ComponentsOverrides,
  ComponentsVariants
} from '@mui/material/styles';

// https://mui.com/customization/theme-components/#default-props
export const defaultProps = {};

// https://mui.com/customization/theme-components/#global-style-overrides
export const styleOverrides: ComponentsOverrides<Theme>['Job'] = {
  root: ({ theme, ownerState }) => ({
    ...theme.mixins.applyBackgroundColor({ ownerState: { backgroundColor: 'surface' }, theme }),
    containerType: 'inline-size',
    position: 'relative',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: 'var(--section-padding) 0',
    gridColumn: 'full-start/full-end',
    gridRow: '1/-1',

    // '[class*="Background-root"] + [class*=Section-contentWrap] & [class*=mainContentWrap]': {
    //   padding: 'var(--grid-gap)',
    //   paddingTop: 0
    // },

    ins: {
      textDecoration: 'none',
      color: 'var(--variant-highlight-color)'
    }
  }),

  introText: { gridColumn: 'start / end' },

  contentOuterGrid: ({ theme, ownerState }) => ({
    margin: 'var(--grid-gap-double) 0',
    rowGap: 'var(--grid-gap-double)',

    [theme.containerBreakpoints.up('sm')]: {
      margin: 'var(--grid-margin-lg) 0'
    }
  }),

  postingsContainerWrap: {
    'marginTop': 'var(--grid-gap-quad)',

    '&:last-of-type': {
      marginBottom: 'var(--grid-gap)'
    }
  },

  resultsContainer: ({ theme }) => ({
    gridColumn: 'start / end',
    gridRow: 2,
    gap: 'var(--grid-gap-double)',
    // display: 'flex',

    [theme.breakpoints.up('md')]: {
      gridColumn: 'two-start/eleven-end'
    }
  }),

  // container: () => ({}),
  filtersContainer: ({ theme }) => ({
    'gridColumn': 'start / end',
    'gridRow': 1,
    'display': 'flex',
    'alignItems': 'center',
    'gap': 'var(--grid-gap)',
    'width': '100%',

    '& > *': {
      'flex': '1 1 1px',

      '&.Mui-focused': {
        borderColor: 'var(--mui-palette-schemes-navyBlue-primary-main)'
      },

      'label': {
        '&.Mui-focused': {
          color: 'var(--mui-palette-schemes-navyBlue-primary-main)'
        }
      }
    },

    [theme.breakpoints.down('md')]: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)'
    },

    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'repeat(1, 1fr)'
    },

    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: 'black'
      }
    }
  })
  // searchField: () => ({}),
  // multiSelectField: () => ({}),
  // resultsStatsContainer: ({ theme }) => ({
  //   display: 'flex',
  //   alignItems: 'center',
  //   justifyContent: 'center',
  //   marginTop: theme.spacing(4)
  // }),
  // stats: () => ({}),
  // clearAll: ({ theme }) => ({
  //   'display': 'inline-flex',
  //   'alignItems': 'center',
  //   'marginLeft': theme.spacing(1),
  //   'color': 'var(--mui-palette-error-main)',
  //   'textDecoration': 'none',
  //   'cursor': 'pointer',
  //   '.MuiSvgIcon-root': {
  //     marginLeft: theme.spacing(0.5)
  //   }
  // }),
  // resultsContainer: ({ theme }) => ({
  //   marginTop: theme.spacing(4)
  // }),
  // departmentContainer: ({ theme }) => ({
  //   marginTop: theme.spacing(2)
  // }),
  // department: ({ theme }) => ({
  //   fontWeight: 700,
  //   color: 'var(--mui-palette-text-primary)'
  // }),
  // postingsContainer: () => ({}),
  // postingItem: ({ theme }) => ({
  //   display: 'flex',
  //   alignItems: 'center',
  //   justifyContent: 'space-between',
  //   padding: theme.spacing(0.5, 0),
  //   [theme.breakpoints.down('md')]: {
  //     flexDirection: 'column'
  //   }
  // }),
  // posting: ({ theme }) => ({
  //   textDecoration: 'none',
  //   [theme.breakpoints.down('md')]: {
  //     textAlign: 'left',
  //     width: '100%'
  //   }
  // }),
  // location: ({ theme }) => ({
  //   [theme.breakpoints.down('md')]: {
  //     textAlign: 'right',
  //     width: '100%'
  //   }
  // })
};

// https://mui.com/customization/theme-components/#adding-new-component-variants
const createVariants = (_theme: Theme): ComponentsVariants['Job'] => [];

export default (theme: Theme): ThemeOptions => ({
  components: {
    Job: {
      defaultProps,
      styleOverrides,
      variants: createVariants(theme)
    }
  }
});
